import { executeEventually } from "../lib/utils/executeEventually";
import { mapGetOrCreate } from "../lib/utils/mapGetOrCreate";
import { UUID } from "./EvidenceDB/DatabaseTypes";
import { DbEventsTableReader } from "./EvidenceDB/DbEventsTableReader";
import { NetworkTrafficRecordingState } from "./NetworkTrafficRecordingState";
import { NewEventAddedToDatabase } from "./StateEvents";



export class NetworkTrafficRecordingDatabaseState extends NetworkTrafficRecordingState {

	update = executeEventually(async () => {
		await DbEventsTableReader.forRecordingUuid(this.recordingUuid).forEventsStartAtIndex(this.highestEventIndexProcessed + 1, this.updateForEvent);
	});

	constructor(recordingUuid: UUID) {
		super(recordingUuid);
		this.update();
	}

	static #forRecordingUuid = new Map<UUID, NetworkTrafficRecordingDatabaseState>();

	static forRecordingUuid = (recordingUuid: UUID) => mapGetOrCreate(NetworkTrafficRecordingDatabaseState.#forRecordingUuid, recordingUuid, () => new NetworkTrafficRecordingDatabaseState(recordingUuid)
	);
}
NewEventAddedToDatabase.addListener(async ({ recordingUuid }) => {
	NetworkTrafficRecordingDatabaseState.forRecordingUuid(recordingUuid)?.update();
});
